import { render, staticRenderFns } from "./LabelsEditor.vue?vue&type=template&id=858034ac&"
import script from "./LabelsEditor.vue?vue&type=script&lang=js&"
export * from "./LabelsEditor.vue?vue&type=script&lang=js&"
import style0 from "./LabelsEditor.vue?vue&type=style&index=0&id=858034ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports